import React, { useState } from 'react';
import { Col, Row } from 'reactstrap';
import DebounceTextInput from 'components/DebounseTextInput';
import ErrorBoundary from 'components/common/ErrorBoundary';
import ForeignSubscriptionPlansTable from './components/ForeignSubscriptionPlansTable';
// import AdvancedFilters from 'components/AdvancedFilters';
// import SubscriptionPlanFilter from '../SubscriptionPlanFilter';

// const initialValues = {
//   planName: null,
// };
const ForeignSubscriptionPlans = ({ toggleDeleteRecord, handleClickEdit }) => {
  const [searchString, setSearchString] = useState('');
  // const [filterValue, setFilterValue] = useState([]);
  // const statusFilter = {
  //   key: 'status',
  //   value: 'ALL',
  //   type: 'STRING',
  //   op: 'EQ',
  // };
  const handleChange = (value) => {
    setSearchString(value);
  };
  // const handleFilters = (val) => {
  //   setFilterValue([
  //     {
  //       key: 'planName',
  //       value: val?.planName?.planName ? val?.planName?.planName : '',
  //       type: 'STRING',
  //       op: 'LIKE',
  //     },
  //   ]);
  // };

  return (
    <div>
      {' '}
      <ErrorBoundary>
        <Row>
          {/* <Col sm={6}>
            <AdvancedFilters
              handleFilters={handleFilters}
              initialValues={initialValues}
              id="plans_all"
            >
              <SubscriptionPlanFilter statusFilter={{}} />
            </AdvancedFilters>
          </Col> */}
          <Col sm={6} className="text-end">
            <DebounceTextInput
              onInputChange={handleChange}
              delay={500} // Set your desired delay in milliseconds
              value={searchString}
              placeholder="Search by Plan"
              positionRight="20px"
              positionTop="-50px"
            />
          </Col>
        </Row>
        <ForeignSubscriptionPlansTable
          searchString={searchString}
          handleClickEdit={handleClickEdit}
          toggleDeleteRecord={toggleDeleteRecord}
        />
      </ErrorBoundary>
    </div>
  );
};

export default ForeignSubscriptionPlans;
